import React, { Fragment, useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./HomeWorkListItemHomePage.scss";
import HomeWorkDetailModal from "../homwork_modals/HomeWorkDetailModal";
import {
  setHomeworkTestInstruction,
  setHomeworkTestDetails,
} from "../../../../../../redux/homework/HomeWorkSlice";
import { isHomeworkInProgress } from "../../../../../../components/tests/exercise_exam/utils/exerciseExamUtils";

const formatHomeworkTopics = (entries) => {
  const names = [];

  (entries || []).forEach((entry) => {
    const name = String(entry?.topic ?? "").trim();
    if (!name) return;
    const alreadyListed = names.some(
      (existing) => existing.toLowerCase() === name.toLowerCase()
    );
    if (!alreadyListed) names.push(name);
  });

  return names.join(", ");
};

const HomeWorkListItemHomePage = ({ item }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const topicListRef = useRef(null);

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
  };

  const startHomeworkTest = (testData) => {
    dispatch(setHomeworkTestDetails(testData));
    if (testData.status == "Pending") {
      history.push({
        pathname: "/homework-instruction",
        state: {
          type: "homework",
          isResume: isHomeworkInProgress(testData),
          returnTo: history.location?.pathname || "/dashboard",
        },
      });
    } else {
      history.push("/homework-solution");
    }
  };

  const {
    status,
    subject,
    faculty,
    homework_date,
    data,
    submisstion_date,
  } = item;

  const topicText = formatHomeworkTopics(data);

  useEffect(() => {
    const element = topicListRef.current;
    if (!element) return;
    setIsOverflow(element.scrollHeight > element.clientHeight + 1);
  }, [topicText]);

  const redirectToHomeworkPage = () => {
    history.push("/homework");
  };

  return (
    <Fragment>
      <div
        className="homework_item_container_homepage"
        // onClick={redirectToHomeworkPage}
      >
        <div className="hmwk_top">
          <div className="hmwk_top_left">
            <div className="hmwk_subject">{subject}</div>
            <div
              className={`hmwk_status ${
                status == "Pending" ? "pending" : "submitted"
              }`}
            >
              {status}
            </div>
          </div>
          <div className="hmwk_top_right">
            <div className="hmwk_top_right_left">Submission Date</div>
            <div className="hmwk_top_right_right">{submisstion_date}</div>
          </div>
        </div>
        <div className="hmwk_middle">
          <div className="hmwk_middle_left">
            <div className="hmwk_topic_list" ref={topicListRef}>
              {topicText}
              {isOverflow && (
                <span
                  className="view-more-btn"
                  onClick={() => setShowDetailModal(true)}
                >
                  View More
                </span>
              )}
            </div>
          </div>
          <div className="hmwk_middle_right">By {faculty}</div>
        </div>
        <div className="hmwk_bottom">
          <div className="hmwk_bottom_left">
            <ul>
              {data?.map((elem) => (
                <li key={elem.label}>{elem.label}</li>
              ))}
            </ul>
          </div>
          <div
            className={`hmwk_bottom_right${
              status == "Pending" && isHomeworkInProgress(item) ? " resume" : ""
            }`}
            onClick={() => startHomeworkTest(item)}
          >
            {status == "Pending"
              ? isHomeworkInProgress(item)
                ? "Resume Homework"
                : "Start Homework"
              : "View Solutions"}
          </div>
        </div>

        <div className="hmwk_final_bottom">
          <div className="hmwk_final_bottom_left">Assigned on</div>
          <div className="hmwk_final_bottom_right">{homework_date}</div>
        </div>
      </div>
      {showDetailModal && (
        <HomeWorkDetailModal handleCloseDetailModal={handleCloseDetailModal} />
      )}
    </Fragment>
  );
};

export default HomeWorkListItemHomePage;
